import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@sr/ui-library';
import { Control, useWatch } from 'react-hook-form';
import { getAddressFieldLabels } from '../../shared/addressLabels';
import { countryAwareRequiredString } from '../../shared/countryAwareStringSchema';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AddressCityFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

/**
 * City/Suburb — label follows the selected address country (AddressFormats),
 * matching the legacy behaviour of AddressDetailsForm.tsx:183-196.
 */
export const AddressCityField = ({ control }: AddressCityFieldProps) => {
  const country = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.addressCountry,
  });
  const label = getAddressFieldLabels(country).city;

  return (
    <FormField
      name={WORKSPACE_DETAILS_FORM_FIELDS.addressCity}
      control={control}
      render={({ field }) => (
        <FormItem>
          <FormLabel asterisk>{label}</FormLabel>
          <FormControl>
            <Input {...field} placeholder={`Enter ${label.toLowerCase()}`} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

AddressCityField.schema = countryAwareRequiredString(
  'city',
  WORKSPACE_DETAILS_FORM_FIELDS.addressCity,
);
